import { Credentials } from '../credentials/credentials';
import { IncidentType } from '../incident-type/incident-type';
import { IncidentLocation } from '../incident-location/incident-location';
import { IncidentSublocation } from '../incident-sublocation/incident-sublocation';

export class Incident {
  loginCredentials: Credentials;
  incidentDate: string;
  incidentLocation: IncidentLocation;
  incidentSublocation: IncidentSublocation;
  incidentType: IncidentType;
  incidentDescription: string;
  reportingEmail: string;
  pictureData: string;
  desktopFileUpload: string;
  deviceId: string;
}
